import { AfterViewInit, ChangeDetectorRef, Component, Input } from '@angular/core';

@Component({
    selector: 'cv-cxone-select-award-card',
    templateUrl: './cxone-select-award-card.component.html',
    styleUrl: './cxone-select-award-card.component.scss'
})
export class CxoneSelectAwardCardComponent implements AfterViewInit {
    @Input() isSelected: boolean = false;
    @Input() awardName: string;
    @Input() coins: number;
    @Input() badgeImage: number;

    constructor(private cdr: ChangeDetectorRef) {}

    ngAfterViewInit() {
        this.cdr.detectChanges();
    }

    checkTruncation(element: HTMLSpanElement): boolean {
        const isTruncated = element.scrollWidth > element.clientWidth;
        return isTruncated;
    }
}
